import type { Target } from 'src/models/TimerTarget';

import { css, html } from 'react-strict-dom';
import { Text, TimerControls } from 'src/components';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';
import { useTimer } from 'src/contexts';

type Props = {
  target: Target;
  /** Opens the Edit project modal, where a typo can be put right. */
  onEdit?: () => void;
};

/**
 * A project inside a client card.  Deliberately flat: it reads as the heading
 * the service order blocks beneath it sit under.  The name opens the edit
 * modal; the row tints while its own timer is running.
 */
export default function ProjectsRow({ target, onEdit }: Props) {
  const running = useTimer().isRunning(target);

  return (
    <html.div
      style={[
        Style.row,
        Style.alignCenter,
        styles.row,
        running && styles.running,
      ]}
    >
      <html.button style={styles.label} onClick={onEdit}>
        <Text typeface="body.small.medium" color="neutral100">
          {target.title}
        </Text>
      </html.button>

      <TimerControls target={target} />
    </html.div>
  );
}

const styles = css.create({
  row: {
    gap: 12,
    paddingBlock: 10,
    paddingInline: 16,
  },
  running: {
    backgroundColor: color.greenBg,
  },
  label: {
    flexGrow: 1,
    minWidth: 0,
    padding: 0,
    borderWidth: 0,
    backgroundColor: 'transparent',
    textAlign: 'left',
    cursor: 'pointer',
  },
});
